import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

// Importação do Bootstrap
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "./index.css"; // Importações do estilo do Iron

// Importação das Traduções
import "./i18n";

// Definir a URL base do Open Graph a partir de REACT_APP_AUTH_API_URL
const authApiUrl =
  process.env.REACT_APP_AUTH_API_URL || "http://localhost:3000";

// Substituir o valor do `og:url` no HTML
document
  .querySelector('meta[property="og:url"]')
  .setAttribute("content", authApiUrl);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
